import React from 'react'
import styles from './HeroComponent.scss'
import {Hero} from 'common/styleguide/Hero'
import {HeroCard} from 'common/styleguide/HeroCard'
import heroImg from 'assets/images/goals/hero.jpg'
import heroImg2x from 'assets/images/goals/hero@2x.jpg'

export class HeroComponent extends React.PureComponent {
  render () {
    return (
      <div className={styles.HeroComponent}>
        <h1>Hero Component</h1>
        <Hero img={heroImg} img2x={heroImg2x} focalPoint='center 75%' label='hero'>
          Retina-ready Hero component
        </Hero>
        <h2>Lorem Ipsum Dolor Sit Amet</h2>
        <p>
          Wevelgem geraardsbergen pereiro landbouwkrediet bretagne, anduze
          around bromont rouleur derby normandie. Cancellara muur, muur
          knockteberg muur-kapelmuur once koppenberg paris-roubaix.
        </p>
        <p>
          Rouleur derby is for lovers het volk cycles goff up. A tourmalet
          vuelta a espana, flanders cutters ombregt normandie parcours kluisberg.
        </p>
        <Hero blur scrimOpacity={[0.2, 0.8]} img={heroImg} img2x={heroImg2x} focalPoint='center center' label='it blurs!'>
          You can customize the display with blur, scrimOpacity, and focalPoint attributes
        </Hero>
        <p>
          Nitto berg ter stene randonneur. Snob kruisberg contador riis,
          festina gavia berendries tete de la course taaienberg giro d'italia,
          liquigas rund um koln. Hell of the north alpe d'huez col de perjuret
          hors categorie hampsten, stijn devolder belleville krabbe
          vandenbroucke rouleur derby is for lovers dwars door vlaanderen.
        </p>
        <h2>Hero Card</h2>
        <HeroCard
          title='Hero Card'
          scrimOpacity={[0.2, 0.8]}
          img={heroImg} img2x={heroImg2x}
          focalPoint='center center'>
          Rouleur derby is for lovers het volk cycles goff up. A tourmalet
          vuelta a espana, flanders cutters ombregt normandie parcours kluisberg.
        </HeroCard>
      </div>
    )
  }
}
